// Import all plugins
import * as bootstrap from 'bootstrap';

// generate scss file from theme.json

import "./seize-the-decade.scss";
import "../node_modules/bootstrap-icons/font/bootstrap-icons.css";

jQuery(function($){
    
    $("a[href=#share]").on('click',function(e){
        e.preventDefault();
        var shareModal = new bootstrap.Modal(document.getElementById('shareModal'));
        shareModal.toggle();        
    });

    $("a[href=#share-native]").each(function(i){
        if (navigator.share && navigator.canShare({url: document.URL })) {
            $(this).on('click',function(e){
                e.preventDefault();
                $(this).parent().show();
                $(this).on('click', function(e){
                    e.preventDefault();
                    navigator.share({
                        url: document.URL,
                        message: $(this).data("message"),
                        title: $(this).data("title")
                    })
                });
            });
        }else {
            $(this).hide();
        }
    });
});
